import {
    BadgeCheck, BarChart3, Binary, BookOpen, Brain, Building2, Calculator,
    Crown, Euro, Eye, FileText, Flag, Gavel, Globe, HeartPulse, Hospital,
    Landmark, Languages, Lightbulb, Map, MapPin, Newspaper, PenTool, Percent,
    PieChart, Puzzle, Radio, Receipt, Ruler, Scale, ScrollText, Shapes,
    Shield, ShieldAlert, ShieldPlus, Ship, Sigma, Siren, SpellCheck,
    Stethoscope, Store, Syringe, Text, TrendingUp, Triangle, Users, Wallet,
    BookA, Baby, School
} from 'lucide-react';

const ICON_MAP = {
    'badge-check': BadgeCheck, 'bar-chart-3': BarChart3, 'binary': Binary,
    'book-a': BookA, 'book-open': BookOpen, 'brain': Brain,
    'building-2': Building2, 'calculator': Calculator, 'crown': Crown,
    'euro': Euro, 'eye': Eye, 'file-text': FileText, 'flag': Flag,
    'gavel': Gavel, 'globe': Globe, 'heart-pulse': HeartPulse,
    'hospital': Hospital, 'landmark': Landmark, 'languages': Languages,
    'lightbulb': Lightbulb, 'map': Map, 'map-pin': MapPin,
    'newspaper': Newspaper, 'pen-tool': PenTool, 'percent': Percent,
    'pie-chart': PieChart, 'puzzle': Puzzle, 'radio': Radio,
    'receipt': Receipt, 'ruler': Ruler, 'scale': Scale,
    'scroll-text': ScrollText, 'shapes': Shapes, 'shield': Shield,
    'shield-alert': ShieldAlert, 'shield-plus': ShieldPlus, 'ship': Ship,
    'sigma': Sigma, 'siren': Siren, 'spell-check': SpellCheck,
    'stethoscope': Stethoscope, 'store': Store, 'syringe': Syringe,
    'text': Text, 'trending-up': TrendingUp, 'triangle': Triangle,
    'users': Users, 'wallet': Wallet,
    'baby': Baby, 'school': School,
};

/**
 * Renders a Lucide icon dynamically from its kebab-case identifiant.
 * Only icons used in matière assets are included.
 */
export default function DynamicIcon({ name, size = 16, className, ...props }) {
    if (!name) return null;
    const IconComponent = ICON_MAP[name];
    if (!IconComponent) return null;
    return <IconComponent size={size} className={className} {...props} />;
}
